goog.provide("shadow.js.shim.module$$amplitude$analytics_browser");
goog.provide("module$shadow_js_shim_module$$amplitude$analytics_browser");
shadow.js.shim.module$$amplitude$analytics_browser = shadow.js.nativeProvides["@amplitude/analytics-browser"] = shadow$bridge("@amplitude/analytics-browser");
module$shadow_js_shim_module$$amplitude$analytics_browser.default = shadow.js.shim.module$$amplitude$analytics_browser;
